import { combineReducers } from "redux";
import modal from "./modal";

const createRootReducer = (history: any) =>
  combineReducers({
    modalStore: modal,
  });

export default createRootReducer;
